import { render, staticRenderFns } from "./CorrespondenceEmailCreate.vue?vue&type=template&id=389feb72&scoped=true"
import script from "./CorrespondenceEmailCreate.vue?vue&type=script&lang=js"
export * from "./CorrespondenceEmailCreate.vue?vue&type=script&lang=js"
import style0 from "./CorrespondenceEmailCreate.vue?vue&type=style&index=0&id=389feb72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389feb72",
  null
  
)

export default component.exports